import { Link } from "react-router";
import Box from "@mui/material/Box";
import { useThemedLayoutContext } from "@refinedev/mui";
import { TeziLogoTP, TeziLogoWithTextTP } from "../../assests/icons/tezi";

type TitleProps = {
  collapsed: boolean;
};

export const ThemedTitleV2: React.FC<TitleProps> = ({ collapsed }) => {
  const { setSiderCollapsed } = useThemedLayoutContext();

  const handleLogoClick = (e: React.MouseEvent) => {
    if (collapsed) {
      e.preventDefault();
      setSiderCollapsed(false);
    }
  };

  return (
    <Link to={"/"}>
      <Box
        display="flex"
        alignItems="center"
        gap={"12px"}
        sx={{
          color: "text.primary",
          cursor: "pointer",
        }}
      >
        {collapsed ? (
          <TeziLogoTP onClick={handleLogoClick}/>
        ) : (
          <>
            <TeziLogoWithTextTP />
          </>
        )}
      </Box>
    </Link>
  );
};
